const brandManufacturerMap: Record<string, string> = {
    audi: 'Audi',
}

const getManufacturer = (brand: string): string => brandManufacturerMap[brand]

export default getManufacturer
